import { render, staticRenderFns } from "./ChooseTreatOrNot.vue?vue&type=template&id=703fe6e8&scoped=true&"
import script from "./ChooseTreatOrNot.vue?vue&type=script&lang=js&"
export * from "./ChooseTreatOrNot.vue?vue&type=script&lang=js&"
import style0 from "./ChooseTreatOrNot.vue?vue&type=style&index=0&id=703fe6e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703fe6e8",
  null
  
)

export default component.exports